// 数据处理相关
import Vue from 'vue';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

/**
 * 根据outputPath获得数据
 * @param {*} root 取值对象
 * @param {*} outputPath 取值路径
 * @return {*} 数据
 */
export const getValueByPath = (root, outputPath) => {
    // 检查outputPath是否合法，否则不进行操作
    if (typeof outputPath !== 'string') {
        console.warn('Typeof outputPath must be string');
        // eslint-disable-next-line
        return undefined;
    }

    if (outputPath) {
        return get(root, outputPath);
    }
    return root;
};

/**
 * 根据输出路径给某对象赋值
 * @param {*} root 赋值对象
 * @param {*} outputPath 输出路径
 * @param {*} value 值
 * @param {*} isReactive 是否使用Vue.set
 * @return Boolean 是否修改成功
 */
/* eslint-disable max-params */
export const setValueByPath = (root, outputPath, value, isReactive = false) => {
    // 检查outputPath是否合法，否则不进行赋值操作
    if (typeof outputPath !== 'string') {
        console.warn('Typeof outputPath must be string');
        return false;
    }
    try {
        if (outputPath) {
            let obj = root;
            // 给值数组开一个口，如果数组里的项目output为空字串，则直接输出值而不用包在key里
            outputPath.split('.')
                .filter(key => key)
                .forEach((key, index, keys) => {
                    if (typeof obj[key] === 'undefined' || obj[key] === null) {
                        // 当前属性不存在，需要添加该属性
                        if (isReactive) {
                            Vue.set(obj, key, index + 1 < keys.length ? {} : value);
                        } else {
                            obj[key] = index + 1 < keys.length ? {} : value;
                        }
                    }

                    // 判断是往下找一层还是赋值
                    if (index + 1 < keys.length) {
                        obj = obj[key];
                    } else if (isReactive && Array.isArray(obj)) {
                        if (key !== 'length') {
                            // 如果是数组需要调用set方法
                            Vue.set(obj, +key, value);
                        } else {
                            obj.splice(value);
                        }
                    } else {
                        obj[key] = value;
                    }
                });

            return true;
        }
        // outputPath为空字串代表根节点
        root = value;
        return true;
    } catch (e) {
        console.warn(e);
        return false;
    }
};
/* eslint-enable max-params */

// 提交数据可能会需要过滤掉以下划线开头命名的中间变量
export function filterLodashKey(obj = {}) {
    const newObj = {};
    Object.keys(obj).forEach(key => {
        if (key && '_' === key[0]) {
            return;
        }
        if (Array.isArray(obj[key])) {
            newObj[key] = obj[key];
        } else if (typeof obj[key] === 'object' && obj[key]) {
            newObj[key] = filterLodashKey(obj[key]);
        } else {
            newObj[key] = obj[key];
        }
    });
    return newObj;
}

/**
 * 可能需要对表单数据进行一下映射处理并输出
 * @param { mapping, formData }
 * mapping格式：{ 'path.a': 'x.y' }
 * formData即表单数据 { x: { y: 1 } }
 * @returns null || { path: { a : 1 } }
 */
export function exportMappedData({ mapping = {}, formData = {} }) {
    if (isEmpty(mapping) || isEmpty(formData)) {
        return null;
    }
    const obj = {};
    Object.keys(mapping).forEach(key => {
        setValueByPath(
            obj,
            key,
            getValueByPath(formData, mapping[key])
        );
    });
    return obj;
}
